import {
  AnalyticsContext
} from "./chunk-3PHLPIUN.mjs";

// src/hooks/use-analytics.ts
import { useContext } from "react";
function useAnalytics() {
  return useContext(AnalyticsContext);
}

export {
  useAnalytics
};
//# sourceMappingURL=chunk-K5I7JMEA.mjs.map